import { gql } from 'graphql-request';

export const SEARCH_SUGGESTION_QUERY = gql`
  query ($searchSuggestionInput: SearchSuggestionInput!) {
    searchSuggestions(searchSuggestionInput: $searchSuggestionInput) {
      __typename
      limit
      totalResultsCount
      version
      currentPageIndex
      suggestions {
        text
        in
      }
    }
  }
`;

export const SEARCH_RESULT_QUERY = gql`
  query ($searchQueryInput: SearchQueryInput!) {
    searchResults(searchQueryInput: $searchQueryInput) {
      __typename
      totalPages
      currentPageIndex
      totalResultsCount
      currentResultsCount
      limit
      isFilterEnabled
      version
      filters {
        title
        queryParam
        isActive
        optionType
        options {
          name
          value
          count
          applied
        }
      }
      results {
        title
        duration
        contentOwner
        businessType
        onAir
        assetType
        originalTitle
        assetSubType
        isIndiaImageEnabled
        releaseDate
        contentType
        distinctSeqId
        broadcastState
        primaryGenre
        languages
        audioLanguages
        id
        billingType
        tier
        listImage
        coverImage
        imageUrl
        searchRelevanceInfo {
          searchCorrelationId
          searchResultPosition
        }
        subtitleLanguages
        image {
          listClean
          square
          appCover
          tvCover
          cover
          list
          portraitClean
          portrait
        }
        tags
        genre {
          id
          value
        }
        actors
      }
    }
  }
`;

export const SEARCH_LANDING_QUERY = gql`
  query ($input: SearchLandingInput!) {
    searchLanding(input: $input) {
      __typename
      id
      title
      originalTitle
      assetSubType
      contentType
      webSideBarFlag
      heroFlag
      textNewsFlag

      genres {
        id
        value
      }
      tags
      modelName
      position
      contents {
        ... on Movie {
          slug
          assetType
          id
          originalTitle
          tags
          title
          businessType
          genres {
            id
            value
          }
          duration
          releaseDate
          subtitleLanguages
          audioLanguages
          languages
          actors
          assetSubType
          actors
          ageRating
          image {
            list
            cover
            listClean
            sticker
            svodCover
            appCover
            channelSquare
            channelList
            square
            portrait
            logo
            verticalBanner
            mobileBanner
            desktopBanner
            banner4k
          }
          viewCount {
            count
            formattedCount
          }
        }
      }
      nextUrl
      page
      size
      totalResults
    }
  }
`;

export const SEARCH_RESULT_RAILS_QUERY = gql`
  query ($searchQueryInRailInput: SearchQueryInRailInput!) {
    hybridSearchResults(searchQueryInRailInput: $searchQueryInRailInput) {
      __typename
      rails {
        id
        title
        tags
        contents {
          __typename
          ... on Episode {
            id
            originalTitle
            tags
            title
            businessType
            genres {
              id
              value
            }
            duration
            releaseDate
            subtitleLanguages
            audioLanguages
            languages
            actors
            assetSubType
            actors
            ageRating
            assetType
            webUrl
            releaseDate
            businessType
            slug
            tvShow {
              id
              assetSubType
              originalTitle
              title
            }
            image {
              list
              cover
              listClean
              sticker
              svodCover
              appCover
              channelSquare
              channelList
              square
              portrait
              logo
              verticalBanner
              mobileBanner
              desktopBanner
              banner4k
            }
            viewCount {
              count
              formattedCount
            }
            contentPartner {
              id
              name
              image {
                rectangleDarkLogo
                rectangleWhiteLogo
                circleDarkLogo
                circleWhiteLogo
              }
              deeplinkUrl
            }
            overlayImageRectangleWhite {
              list
              cover
              listClean
              sticker
              svodCover
              appCover
              channelSquare
              channelList
              square
              portrait
              logo
              verticalBanner
              mobileBanner
              desktopBanner
              banner4k
            }
          }
          ... on Movie {
            id
            originalTitle
            tags
            title
            businessType
            genres {
              id
              value
            }
            duration
            releaseDate
            subtitleLanguages
            audioLanguages
            languages
            actors
            assetSubType
            actors
            ageRating
            assetType
            webUrl
            releaseDate
            businessType
            slug
            image {
              list
              cover
              listClean
              sticker
              svodCover
              appCover
              channelSquare
              channelList
              square
              portrait
              logo
              verticalBanner
              mobileBanner
              desktopBanner
              banner4k
            }
            viewCount {
              count
              formattedCount
            }
            contentPartner {
              id
              name
              image {
                rectangleDarkLogo
                rectangleWhiteLogo
                circleDarkLogo
                circleWhiteLogo
              }
              deeplinkUrl
            }
            overlayImageRectangleWhite {
              list
              cover
              listClean
              sticker
              svodCover
              appCover
              channelSquare
              channelList
              square
              portrait
              logo
              verticalBanner
              mobileBanner
              desktopBanner
              banner4k
            }
          }
        }
        total
      }
      queryId
      total
      filters {
        title
        queryParam
        isActive
        optionType
        options {
          name
          value
          count
          applied
        }
      }
    }
  }
`;
